import React, { useState, useEffect } from 'react'
import { Table, Icon, Panel, Row, Col, Grid, Avatar } from 'rsuite'
import './styles.less'
import { budgetFormat } from '../../utils/formatterUtil'

export default function TableProjectHistoryForResponsible({ schema, header }) {
  const [isLoadingTable, setIsLoadingTable] = useState(true)
  const { Column, HeaderCell, Cell } = Table

  useEffect(() => {
    if (!schema.tableData) {
      setIsLoadingTable(true)
    } else {
      setIsLoadingTable(false)
    }
  }, [schema.tableData])

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <Grid fluid>
        <Row>
          <Col
            xs={5}
            sm={5}
            md={5}
            lg={5}
            style={{
              width: 40,
              height: 40,
              // background: '#f5f5f5',
              background: '#f0f0f0',
              borderRadius: 20,
              marginTop: 2,
              overflow: 'hidden',
              display: 'inline-block',
            }}
          >
            <Icon
              icon={rowData[dataKey].icon}
              size={'lg'}
              style={{ marginLeft: 6, marginTop: 10 }}
            />
          </Col>

          <Col xs={15} sm={15} md={15} lg={15} style={{ marginTop: 10 }}>
            <span style={{ marginTop: 10 }}>{rowData[dataKey].label}</span>
          </Col>
        </Row>
      </Grid>
    </Cell>
  )

  const TagCell = ({ rowData, dataKey, ...props }) => {
    let color
    if (rowData[dataKey].code == 1) {
      color = '#24c2a1'
    } else if (rowData[dataKey].code == 2) {
      color = '#24c2a1'
    } else if (rowData[dataKey].code == 3) {
      color = '#f88781'
    } else if (rowData[dataKey].code == 4) {
      color = '#f8bb6a'
    } else if (rowData[dataKey].code == 5) {
      color = '#70b4e5'
    } else if (rowData[dataKey].code == 6) {
      color = '#8cc2ff'
    }

    return (
      <Cell {...props} style={{ padding: 13 }}>
        <div
          className="tag"
          style={{
            backgroundColor: color,
          }}
        >
          <span className="tag__text">{rowData[dataKey].label}</span>
        </div>
      </Cell>
    )
  }

  return (
    <>
      <Panel
        className="table-project-history-for-responsible"
        header={header}
        bordered
        bodyFill
        collapsible
        defaultExpanded
      >
        <Table
          wordWrap
          height={400}
          data={schema.tableData}
          // onRowClick={(data) => {
          //   console.log(data)
          // }}
          loading={isLoadingTable}
          headerHeight={65}
        >
          <Column align="center" width={120} fixed>
            <HeaderCell>
              <span>{schema.projectCodeTitle}</span>
            </HeaderCell>
            <Cell dataKey="id" />
          </Column>

          <Column width={250}>
            <HeaderCell>
              <span>{schema.projectNameTitle}</span>
            </HeaderCell>
            <Cell dataKey="projectName" />
          </Column>

          <Column width={151}>
            <HeaderCell>
              <span>{schema.projectStartDateTitle}</span>
            </HeaderCell>
            <Cell dataKey="startdate" />
          </Column>

          <Column width={150}>
            <HeaderCell>
              <span>{schema.projectEndDateTitle}</span>
            </HeaderCell>
            <Cell dataKey="enddate" />
          </Column>

          <Column width={150}>
            <HeaderCell>
              <span>{schema.projectBudgetTitle}</span>
            </HeaderCell>
            <Cell align={'right'}>
              {(rowData) => {
                return <span>{budgetFormat(rowData.bugetCost)}</span>
              }}
            </Cell>
          </Column>

          <Column width={130}>
            <HeaderCell>
              <span>{schema.projectTypeTitle}</span>
            </HeaderCell>
            <ImageCell dataKey="type" />
          </Column>

          <Column width={170}>
            <HeaderCell>
              <span>{schema.projectResultTitle}</span>
            </HeaderCell>
            <Cell dataKey="result" />
          </Column>

          <Column width={100}>
            <HeaderCell>
              <span>{schema.projectStausTitle}</span>
            </HeaderCell>
            <TagCell dataKey="colorstatus" />
          </Column>
        </Table>
      </Panel>
    </>
  )
}
